import React, { useState } from "react";
import PropTypes from "prop-types";
import { BsMicMute } from "react-icons/bs";
import { MdCallEnd } from "react-icons/md";
import { IoHandRightOutline } from "react-icons/io5";
import { HiOutlineSpeakerWave } from "react-icons/hi2";


import { cn } from "../../../helpers/utils/stylecss-utils";

const audioToolButtons = [
  // { id: "mute", label: "Mute", icon: BsMicMute },
  // { id: "interrupt", label: "Interrupt", icon: IoHandRightOutline },
  // { id: "speaker", label: "Speaker", icon: HiOutlineSpeakerWave },
  { id: "end", label: "End", icon: MdCallEnd },
];

const AudioButton = ({ id, label, icon: Icon, actived, onPressed }) => {
  return (
    <div className="flex flex-col justify-center items-center space-y-1.5 lg:w-auto w-1/5">
      <button
        onClick={() => onPressed(id)}
        className={cn(
          `w-14 h-14 flex-shrink-0 cursor-pointer flex items-center justify-center rounded-full 
          text-gray-300 bg-transparent border border-gray-300  hover:opacity-50
          transition-all duration-300`,
          {
            "bg-white border-gray-50 text-gray-700": actived,
            "bg-red-700 border-red-700 text-white": id === "end",
          }
        )}
      >
        <Icon size={21} />
      </button>
      <span
        className={cn("text-[0.79rem] invert font-medium whitespace-nowrap", {
          "text-gray-700 invert-0": actived,
        })}
      >
        {label}
      </span>
    </div>
  );
};

function AudioControlTool({ settingsState, controlClick }) {
  const [event, setEvent] = useState(null);

  const handlePressed = (event) => {
    console.log(event);
    // window.alert("Trigger button =" + event);
    setEvent((prev) => (prev === event ? null : event));

    controlClick(event);
  };

  return (
    <div className="w-full flex items-center justify-center p-4">
      <div className="flex flex-wrap items-center justify-center gap-11">
        {audioToolButtons.map(({ id, label, icon }, idx) => {
          const isActive = event === id;
          return (
            <AudioButton
              key={idx}
              id={id}
              label={label}
              icon={icon}
              actived={isActive}
              onPressed={handlePressed}
            />
          );
        })}
      </div>
    </div>
  );
}

AudioControlTool.propTypes = {
  settingsState: PropTypes.any,
  controlClick: PropTypes.func,
};

export default AudioControlTool;
